import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

const NotificationConfigActionsToggle = ({ notificationConfig, t, handleClick = () => {} }) => (
  <Form.Button
    text={t(notificationConfig.active ? 'actions.deactivate' : 'actions.activate')}
    color={notificationConfig.active ? 'outline-warning' : 'outline-info'}
    extraClassName={'btn-sm'}
    isLoading={notificationConfig.isLoading}
    onClick={(e) => {
      e.preventDefault();
      handleClick(notificationConfig.id);
    }}
  />
);

export default translate()(NotificationConfigActionsToggle);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/components/list/actions/NotificationsConfigActionsToggle.js